// Issue 36 (backend A2): when the backend's DB pool is saturated it now answers
// 503 {"error":"server_busy"} + Retry-After instead of silently returning empty
// data. This module makes every axios call: (1) show a small "System busy" banner,
// (2) wait the server-suggested delay, (3) retry ONCE. Pages no longer render
// blank because of a momentary pool spike.
import axios from "axios";

let bannerEl = null;
let bannerTimer = null;

function showBusyBanner(message) {
  if (!bannerEl) {
    bannerEl = document.createElement("div");
    bannerEl.setAttribute("role", "status");
    bannerEl.style.cssText = [
      "position:fixed", "top:16px", "left:50%", "transform:translateX(-50%)",
      "z-index:99999", "background:#212529", "color:#ffc107",
      "padding:10px 22px", "border-radius:8px", "font-size:14px",
      "box-shadow:0 4px 14px rgba(0,0,0,.35)", "transition:opacity .3s",
    ].join(";");
    document.body.appendChild(bannerEl);
  }
  bannerEl.textContent = message;
  bannerEl.style.opacity = "1";
  clearTimeout(bannerTimer);
  bannerTimer = setTimeout(() => {
    if (bannerEl) bannerEl.style.opacity = "0";
  }, 4000);
}

export function attachBusyRetry(instance) {
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const resp = error.response;
      const cfg = error.config || {};
      const isBusy503 =
        resp && resp.status === 503 && resp.data && resp.data.error === "server_busy";
      if (isBusy503 && !cfg._busyRetried) {
        cfg._busyRetried = true; // one retry only — after that, surface the error
        const seconds = parseInt(resp.headers && resp.headers["retry-after"], 10) || 2;
        showBusyBanner("System busy — retrying…");
        await new Promise((resolve) => setTimeout(resolve, seconds * 1000));
        return instance(cfg);
      }
      if (isBusy503) {
        showBusyBanner("System is busy — please try again in a moment.");
      }
      return Promise.reject(error);
    }
  );
  return instance;
}

// Components across the app import the global axios directly — cover them all.
attachBusyRetry(axios);
